export default {
  // baseURL: process.env.NODE_ENV === 'development' ? 'http://10.10.3.100' : '',
  baseURL: process.env.NODE_ENV === 'development' ? '' : '',
  // http://192.168.40.128:5000
  title: '运行监控服务系统',
  version: 'v2.3.8-hb',
  timeout: 60 * 1000
}
